/**
 * quill-image-uploader の imageBlot を @vueup/vue-quill と同じ Quill に登録する。
 * Vite のチャンク分割で別 Quill インスタンスに登録されると
 * [Parchment] Unable to create imageBlot が発生する。
 */
import { Quill } from '@vueup/vue-quill'
import ImageUploader from 'quill-image-uploader'

let registered = false

export const ensureQuillImageUploaderRegistered = (): void => {
  if (registered) {
    return
  }
  registered = true

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Block = Quill.import('blots/block') as any

  class LoadingImage extends Block {
    static create(src: unknown) {
      const node = super.create(src) as HTMLElement
      if (src === true) {
        return node
      }
      const image = document.createElement('img')
      image.setAttribute('src', String(src))
      node.appendChild(image)
      return node
    }

    deleteAt(index: number, length: number) {
      super.deleteAt(index, length)
      ;(this as { cache?: unknown }).cache = {}
    }

    static value(domNode: HTMLElement) {
      const { src, custom } = domNode.dataset
      return { src, custom }
    }
  }

  LoadingImage.blotName = 'imageBlot'
  LoadingImage.className = 'image-uploading'
  LoadingImage.tagName = 'span'

  if (!Quill.imports['formats/imageBlot']) {
    Quill.register({ 'formats/imageBlot': LoadingImage })
  }
  if (!Quill.imports['modules/imageUploader']) {
    Quill.register('modules/imageUploader', ImageUploader)
  }
}

ensureQuillImageUploaderRegistered()
